/*
 * Harmony Health | hh-base.js
 * Theme ArtWeb v1.0.0 · © Studio Art Web · https://studioartweb.com.br
 * Comportamentos pequenos da fundação do tema, sem biblioteca:
 * - <hh-beneficios>: abaixo de 1100 px mostra um benefício por vez e troca a
 *   cada 5 s; pausa no toque, no foco, no hover e no botão de pausa; com
 *   movimento reduzido fica parada no primeiro e o botão avança manualmente.
 * - <hh-nav-inferior>: barra de navegação fixa do celular; "Menu" abre a gaveta do
 *   cabeçalho; "Sacola" abre a
 *   sacola lateral do Horizon e o contador acompanha o evento cart:update.
 * Carregado como módulo em layout/theme.liquid.
 */

const reduz = window.matchMedia('(prefers-reduced-motion: reduce)');

class HHBeneficios extends HTMLElement {
  #timer = 0;
  #i = 0;
  #pausado = false;
  #mq = window.matchMedia('(min-width: 1100px)');
  #ctrl = new AbortController();

  connectedCallback() {
    this.itens = [...this.querySelectorAll('.hh-beneficios__lista:not(.hh-beneficios__copia) [data-hh-beneficio]')];
    this.botao = this.querySelector('[data-hh-pausa]');
    if (this.itens.length < 2) return;
    const { signal } = this.#ctrl;
    this.addEventListener('pointerenter', () => this.#para(), { signal });
    this.addEventListener('pointerleave', () => this.#segue(), { signal });
    this.addEventListener('focusin', () => this.#para(), { signal });
    this.addEventListener('focusout', () => this.#segue(), { signal });
    this.botao?.addEventListener(
      'click',
      () => {
        if (reduz.matches) {
          this.#mostra(this.#i + 1);
          return;
        }
        this.#pausado = !this.#pausado;
        this.botao.setAttribute('aria-pressed', String(this.#pausado));
        this.#pausado ? this.#para() : this.#segue();
      },
      { signal }
    );
    this.#mq.addEventListener('change', () => this.#inicia(), { signal });
    reduz.addEventListener('change', () => this.#inicia(), { signal });
    document.addEventListener('visibilitychange', () => (document.hidden ? this.#para() : this.#segue()), { signal });
    this.#inicia();
  }

  disconnectedCallback() {
    this.#ctrl.abort();
    clearInterval(this.#timer);
  }

  #inicia() {
    clearInterval(this.#timer);
    if (this.#mq.matches) {
      this.itens.forEach((el) => el.removeAttribute('aria-hidden'));
      this.classList.remove('is-rodando');
      return;
    }
    this.classList.add('is-rodando');
    this.#mostra(this.#i);
    this.#segue();
  }

  #mostra(n) {
    this.#i = (n + this.itens.length) % this.itens.length;
    this.itens.forEach((el, k) => {
      const ativo = k === this.#i;
      el.classList.toggle('is-ativo', ativo);
      if (ativo) el.removeAttribute('aria-hidden');
      else el.setAttribute('aria-hidden', 'true');
    });
  }

  #para() {
    clearInterval(this.#timer);
    this.#timer = 0;
  }

  #segue() {
    if (this.#pausado || reduz.matches || this.#mq.matches || document.hidden) return;
    if (this.matches(':hover') || this.contains(document.activeElement)) return;
    clearInterval(this.#timer);
    this.#timer = window.setInterval(() => this.#mostra(this.#i + 1), 5000);
  }
}

class HHNavInferior extends HTMLElement {
  #ctrl = new AbortController();

  connectedCallback() {
    const { signal } = this.#ctrl;
    this.contador = this.querySelector('[data-hh-contador]');
    this.querySelector('[data-hh-sacola]')?.addEventListener(
      'click',
      (evento) => {
        const gaveta = document.querySelector('cart-drawer-component');
        if (gaveta && typeof gaveta.open === 'function') {
          evento.preventDefault();
          gaveta.open();
        }
      },
      { signal }
    );
    // Menu abre a gaveta do menu do cabeçalho; sem ela, leva para todos os produtos
    this.querySelector('[data-hh-menu]')?.addEventListener(
      'click',
      () => {
        const gatilho = document.querySelector('header-drawer summary');
        if (gatilho) gatilho.click();
        else window.location.href = `${window.Shopify?.routes?.root || '/'}collections/all`;
      },
      { signal }
    );
    this.querySelector('[data-hh-busca]')?.addEventListener(
      'click',
      (evento) => {
        const busca = document.querySelector('#search-modal');
        if (busca && typeof busca.showDialog === 'function') {
          evento.preventDefault();
          busca.showDialog();
        }
      },
      { signal }
    );
    document.addEventListener('cart:update', () => this.#atualiza(), { signal });
    window.addEventListener('pageshow', (e) => e.persisted && this.#atualiza(), { signal });
  }

  disconnectedCallback() {
    this.#ctrl.abort();
  }

  async #atualiza() {
    if (!this.contador) return;
    try {
      const resposta = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
      if (!resposta.ok) return;
      const sacola = await resposta.json();
      const n = Number(sacola.item_count) || 0;
      this.contador.textContent = n > 99 ? '99+' : String(n);
      this.contador.hidden = n === 0;
    } catch (erro) {
      /* sem rede: o contador continua com o último valor */
    }
  }
}

if (!customElements.get('hh-beneficios')) customElements.define('hh-beneficios', HHBeneficios);
if (!customElements.get('hh-nav-inferior')) customElements.define('hh-nav-inferior', HHNavInferior);
